import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";

import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import Loader from "./core/common/loader";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import "../src/style/icon/bootstrap/bootstrap-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { HelmetProvider } from "react-helmet-async";
import "react-datepicker/dist/react-datepicker.css";
import { AuthProvider } from "./context/authcontext";
import { HeroUIProvider } from "@heroui/system";
import "./styles/heroui-generated.css";
import { suppressResizeObserverErrors } from "./utils/chartUtils";
import { EmailProvider } from "./context/emailContext";
import "../src/index.scss";
import { ChatNotificationProvider } from "./feature-module/application/components/chat/ChatNotificationContext";
import ChatMessageToast from "./components/notification/ChatMessageToast";
import PwaInstallBanner from "./components/notification/PwaInstallBanner";

import { preloadCriticalAssets } from "./utils/cacheUtils";
import FontLoader, {
  optimizeFontLoading,
  preloadLocalFonts,
} from "./components/FontLoader";
import { preloadCriticalIcons } from "./hooks/useIconCache";
import { initializeStorageCleanup } from "./utils/storageCleanup";

// Suppress ResizeObserver loop error which is common with chart libraries
const resizeObserverErrorSuppressor = (e: ErrorEvent) => {
  if (
    e.message &&
    e.message.includes(
      "ResizeObserver loop completed with undelivered notifications"
    )
  ) {
    e.stopImmediatePropagation();
    return false;
  }
  return true;
};

// Add global error handler and chart-specific error suppression
window.addEventListener("error", resizeObserverErrorSuppressor);
suppressResizeObserverErrors();

// Initialize caching and optimization
const initializeOptimizations = async () => {
  try {
    optimizeFontLoading();
    await preloadCriticalAssets();
    await preloadCriticalIcons();
    // Clean up old tenant_id localStorage key
    initializeStorageCleanup();
  } catch (error) {
    console.warn("Cache optimization initialization failed:", error);
  }
};

document.addEventListener('mousedown', (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.classList.contains('offcanvas-backdrop')) {
    const openOffcanvas = document.querySelector('.offcanvas.show') as HTMLElement;
    if (openOffcanvas) {
      const closeBtn = openOffcanvas.querySelector('[data-bs-dismiss="offcanvas"]') as HTMLElement;
      if (closeBtn) {
        closeBtn.click();
      } else {
        const bsOffcanvas = (window as any).bootstrap?.Offcanvas?.getInstance(openOffcanvas);
        if (bsOffcanvas) bsOffcanvas.hide();
      }
    }
  }
});

initializeOptimizations();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <AuthProvider>
      <EmailProvider>
        <HelmetProvider>
          <FontLoader loadGoogleFonts={false} />
          <HeroUIProvider>
            <BrowserRouter basename={base_path}>
              <ChatNotificationProvider>
                <Loader />
                <ALLRoutes />
                <ChatMessageToast />
                <PwaInstallBanner />
              </ChatNotificationProvider>
            </BrowserRouter>
          </HeroUIProvider>
        </HelmetProvider>
      </EmailProvider>
    </AuthProvider>
  </Provider>
);
